import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    valueCard: { fontWeight: 'bold' },
    valueCardGray: { color: palette.navSuperAdminActions },
    valueCardGreen: { color: palette.navAdminActions },
    valueCardBlue: { color: palette.navOperatorActions },
    valueCardYellow: { color: palette.navCompanyContextActions },
  });
